import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageViewComponent } from './message-view/message-view.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';

@NgModule({
  declarations: [MessageViewComponent],
  exports: [MessageViewComponent],
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    TranslateModule,
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatGridListModule,
  ],
})
export class MessagesModule {}
